import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customBaseURL, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_QUES_ANS, GET_QUES_ANS_SUCCESS, GET_QUES_ANS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getQuestionAnswer({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/adib/admin/questions`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_QUES_ANS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_QUES_ANS_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_QUES_ANS_ERROR, payload: error });
  }
}

export function* watchgetQuestionAnswer() {
  yield takeEvery(GET_QUES_ANS, getQuestionAnswer);
}

function* getQuestionAnswerSaga() {
  yield all([fork(watchgetQuestionAnswer)]);
}

export default getQuestionAnswerSaga;
